/* eslint-disable no-console */

// This file implements a custom Logger object, that handles making console logs throughout our application
// We have an eslint rule against using the console directly in the code

const Logger = {
  error: (message: any, ...args: any[]) => {
    // to be used for errors
    console.error(message, ...args);
  },
  log: (message: any, ...args: any[]) => {
    // to be used for debugging purposes ONLY, we should not leave logs in our code
    console.log(message, ...args);
  },
  warn: (message: any, ...args: any[]) => {
    console.warn(message, ...args);
  },
};

export default Logger;
